/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailContactViewModel } from './EmailContactViewModel';
import {
    EmailContactViewModelFromJSON,
    EmailContactViewModelFromJSONTyped,
    EmailContactViewModelToJSON,
} from './EmailContactViewModel';
import type { TelephoneContactViewModel } from './TelephoneContactViewModel';
import {
    TelephoneContactViewModelFromJSON,
    TelephoneContactViewModelFromJSONTyped,
    TelephoneContactViewModelToJSON,
} from './TelephoneContactViewModel';

/**
 * 
 * @export
 * @interface ContactDetailsViewModel
 */
export interface ContactDetailsViewModel {
    /**
     * 
     * @type {number}
     * @memberof ContactDetailsViewModel
     */
    partyId?: number;
    /**
     * 
     * @type {TelephoneContactViewModel}
     * @memberof ContactDetailsViewModel
     */
    primaryTelephoneContact?: TelephoneContactViewModel;
    /**
     * 
     * @type {TelephoneContactViewModel}
     * @memberof ContactDetailsViewModel
     */
    secondaryTelephoneContact?: TelephoneContactViewModel;
    /**
     * 
     * @type {EmailContactViewModel}
     * @memberof ContactDetailsViewModel
     */
    primaryEmailContact?: EmailContactViewModel;
    /**
     * 
     * @type {EmailContactViewModel}
     * @memberof ContactDetailsViewModel
     */
    secondaryEmailContact?: EmailContactViewModel;
}

/**
 * Check if a given object implements the ContactDetailsViewModel interface.
 */
export function instanceOfContactDetailsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactDetailsViewModelFromJSON(json: any): ContactDetailsViewModel {
    return ContactDetailsViewModelFromJSONTyped(json, false);
}

export function ContactDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partyId': !exists(json, 'PartyId') ? undefined : json['PartyId'],
        'primaryTelephoneContact': !exists(json, 'PrimaryTelephoneContact') ? undefined : TelephoneContactViewModelFromJSON(json['PrimaryTelephoneContact']),
        'secondaryTelephoneContact': !exists(json, 'SecondaryTelephoneContact') ? undefined : TelephoneContactViewModelFromJSON(json['SecondaryTelephoneContact']),
        'primaryEmailContact': !exists(json, 'PrimaryEmailContact') ? undefined : EmailContactViewModelFromJSON(json['PrimaryEmailContact']),
        'secondaryEmailContact': !exists(json, 'SecondaryEmailContact') ? undefined : EmailContactViewModelFromJSON(json['SecondaryEmailContact']),
    };
}

export function ContactDetailsViewModelToJSON(value?: ContactDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'PartyId': value.partyId,
        'PrimaryTelephoneContact': TelephoneContactViewModelToJSON(value.primaryTelephoneContact),
        'SecondaryTelephoneContact': TelephoneContactViewModelToJSON(value.secondaryTelephoneContact),
        'PrimaryEmailContact': EmailContactViewModelToJSON(value.primaryEmailContact),
        'SecondaryEmailContact': EmailContactViewModelToJSON(value.secondaryEmailContact),
    };
}

